var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContentStatShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1120_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7488 18.2546C38.1785 17.8665 38.1899 17.1957 37.7736 16.7934L24.4882 3.95299C23.8535 3.33954 22.7932 3.78932 22.7932 4.67204V10.0321C17.8272 9.95539 14.0963 11.2542 11.3237 13.2447C8.50779 15.2663 6.7136 17.977 5.608 20.6045C4.50341 23.2295 4.07774 25.7903 4.00995 27.5461C3.97652 28.412 4.02816 29.1267 4.15223 29.5633C4.18394 29.6749 4.22678 29.792 4.28837 29.8955C4.34258 29.9867 4.45727 30.1454 4.66565 30.2117C4.91639 30.2915 5.12921 30.1891 5.25256 30.0832C5.36389 29.9876 5.4387 29.8644 5.49047 29.7608L5.49705 29.7477L5.50234 29.7353L5.50284 29.7342L5.50411 29.7313L5.51432 29.7091C5.52418 29.688 5.54023 29.6546 5.56294 29.61C5.60837 29.5209 5.68042 29.3874 5.78287 29.2191C5.98783 28.8824 6.31409 28.407 6.79199 27.8694C7.74659 26.7955 9.30921 25.4694 11.729 24.5015C13.1064 23.9505 15.4023 23.6998 17.6533 23.6592C19.8014 23.6205 21.8049 23.7741 22.7932 23.992V29.5093C22.7932 30.3758 23.8203 30.8322 24.4634 30.2515L37.7488 18.2546Z",
    fill: "#FBFBFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.656 16.8274C34.6157 15.7119 33.656 14.1206 33.656 14.1206L32 11.2169L24.4882 3.95299C23.8535 3.33954 22.7932 3.78932 22.7932 4.67204V10.0321C17.8272 9.95539 14.0963 11.2542 11.3237 13.2447C8.50779 15.2663 6.7136 17.977 5.608 20.6045C4.50341 23.2295 4.07774 25.7903 4.00995 27.5461C3.97652 28.412 4.02816 29.1267 4.15223 29.5633C4.18394 29.6749 4.22678 29.792 4.28837 29.8955C4.34258 29.9867 4.45727 30.1454 4.66565 30.2117C4.91639 30.2915 5.12921 30.1891 5.25256 30.0832C5.36389 29.9876 5.4387 29.8644 5.49047 29.7608L5.49705 29.7477L5.50234 29.7353L5.50284 29.7342L5.50411 29.7313L5.51432 29.7091C5.52418 29.688 5.54023 29.6546 5.56294 29.61C5.60837 29.5209 5.68042 29.3874 5.78287 29.2191C5.98783 28.8824 6.31409 28.407 6.79199 27.8694C7.74659 26.7955 13.0432 23.0372 16.0432 21.5372C18.5432 20.0372 22.7932 19.0372 22.7932 19.0372V25.0372C22.7932 25.9038 23.8203 26.3602 24.4634 25.7794L33.656 16.8274Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1120_4",
    x: 0,
    y: 0.0000439584,
    width: 42.0786,
    height: 34.8412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.33
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1120_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1120_4",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentStatShare);
export default __webpack_public_path__ + "static/media/content-stat-share.3fe643a8c44e5b09a13b2c9f1e858533.svg";
export { ForwardRef as ReactComponent };